import React, {useState} from "react";
  import India from "@react-map/india";

const IndianMap = () => {

      const handleselectstate = (t) => {
        console.log('t >>', t);
      }
    return (
        <div style={{ marginTop: 10}}>
           <India onSelect={handleselectstate} size={300} hoverColor="orange"  type = 'select-single'/>
        </div>
    )
}

export default IndianMap